import { Button, SearchBox } from '@octano/global-ui';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { useValidations } from '../../../../hooks/useValidations';
import { TranslationsKeys } from '../../../../locales/translations';
import { useStudentsRemovalRequestStudentstList } from './StudentsRemovalRequestStudentsListLoader';

interface SearchFiltersType {
  studentNameOrId: string;
}

export function StudentsRemovalRequestFilters() {
  const { updateQuery } = useStudentsRemovalRequestStudentstList();
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_STUDENTS,
  );
  const { control, handleSubmit, reset } = useForm<SearchFiltersType>({
    defaultValues: {
      studentNameOrId: '',
    },
  });

  const { validateMinLength, msgValidations } = useValidations();

  const localSubmit = useCallback(
    (values: SearchFiltersType) => {
      updateQuery({
        page: 1,
        studentNameOrId: values.studentNameOrId,
      });
    },
    [updateQuery],
  );

  return (
    <form onSubmit={handleSubmit(localSubmit)}>
      <Row>
        <Col xs={12} md={4}>
          <SearchBox
            name="studentNameOrId"
            label={t('students.filters.student')}
            placeholder={t('students.filters.studentPlaceholder')}
            control={control}
            clear={() => reset({ studentNameOrId: '' })}
            minLength={3}
            rules={{
              required: msgValidations.required,
              validate: {
                minLength: validateMinLength(3),
              },
            }}
          />
        </Col>
        <Col xs={12} md={4} className="ml-auto">
          <div className="d-flex justify-content-end mt-4">
            <Button
              type="submit"
              color="primary"
              className="mb-3"
              size="md"
              text={t('students.filters.search')}
            />
          </div>
        </Col>
      </Row>
    </form>
  );
}
